import { darken } from "@mui/material";

const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "20px",
    bgcolor: theme.palette.secondary.darker,
    justifyContent: "center",
    width: "400px",
    minHeight: "350px",
    maxWidth: "80vw",
    maxHeight: "90vh",
    padding: {
      xs: "20px",
      sm: "20px",
    },
  },
  paperInterno: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "20px",
    width: "360px",
    bgcolor: theme.palette.background.modalContrast,
    minHeight: "270px",
    mt: "50px",
    maxWidth: "70vw",
    paddingY: {
      xs: "10px",
      sm: "20px",
    },
    paddingBottom: "20px",
  },
  header: {
    display: "flex",
    justifyContent: "center",
    mt: 2,
  },
  circleWhiteMode: {
    position: "absolute",
    top: "20px",
    width: "88px",
    height: "88px",
    bgcolor: `${theme.palette.secondary.darker}`,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  circleTransparent: {
    position: "absolute",
    top: "20px",
    width: "88px",
    height: "88px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: `${theme.palette.colors?.orange?.medium || "#FFA726"}6b`,
  },
  circleFixed: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "66px",
    height: "66px",
    borderRadius: "50%",
    bgcolor: theme.palette.colors?.orange?.medium || "#FFA726",
  },
  typographyIcon: {
    fontSize: "50px",
    fontWeight: 700,
    color: theme.palette.white.main,
  },
  title: {
    mt: "8px",
    fontSize: "24px",
    fontWeight: 700,
  },
  boxTextContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    mt: 2,
    gap: 1,
    paddingX: 2,
  },
  typographyText: {
    fontSize: "16px",
    textAlign: "center",
    "@media (max-width: 465px)": {
      fontSize: "16px",
    },
  },
  ticketsListContainer: {
    mt: 1.5,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    width: "100%",
    maxHeight: "180px",
    overflowY: "auto",
  },
  ticketCard: {
    bgcolor: "action.hover",
    p: 1.5,
    borderRadius: "12px",
    border: "1px solid",
    borderColor: "divider",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
  },
  protocolLabel: {
    fontSize: "15px",
    textAlign: "center",
  },
  protocolLink: {
    color: theme.palette.primary?.main || "#1976d2",
    fontWeight: "bold",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: "15px",
    "&:hover": { opacity: 0.8 },
  },
  dateText: {
    fontSize: "13px",
    textAlign: "center",
    fontWeight: 500,
  },
  boxButtons: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    mt: 3,
    "@media (max-width: 412px)": {
      mt: 2,
    },
  },
  buttonVoltar: {
    borderRadius: "10px",
  },
  buttonProsseguir: {
    borderRadius: "10px",
    bgcolor: theme.palette.colors?.orange?.medium || "#FFA726",
    color: theme.palette.white.main,
    "&:hover": {
      bgcolor: darken(
        theme.palette.colors?.orange?.medium || "#FFA726",
        0.2,
      ),
    },
  },
});

export default styles;
